gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

$( document ).ready( function(){
    ScrollTrigger.refresh();
})
  
//Handling Scroll Position on Resize
var pageST = ScrollTrigger.create({});

var progress = 0;
ScrollTrigger.addEventListener("refreshInit", function() {
    progress = pageST.scroll() / ScrollTrigger.maxScroll(window);
});
ScrollTrigger.addEventListener("refresh", function() {
    pageST.scroll(progress * ScrollTrigger.maxScroll(window));
});



// Utility for Canvas
const widthToHeight = 1920 / 1080;
const currentFrame = (index, JSONVector) => (
    JSONVector['figure' + index.toString().padStart(4, '0')]
)

function preloadImages(JSONVector) {
    var imagesVector = [];
    for (let i = 1; i <= Object.keys(JSONVector).length; i++) {
        const img = new Image;
        img.src = currentFrame(i, JSONVector);
        imagesVector.push(img)
    }
    return imagesVector; 
}

function updateImage(index, imgs, context, xPos, yPos, width, height) {
    try{
        context.drawImage(imgs[index], xPos, yPos, width, height);
    } catch{
        console.log("prova")
    }
}

document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
$(window).resize(function(){
    document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
}) 


// handling animations on section "introductions"
gsap.set(".unico-page-introduction-figure", {autoAlpha: 0});
gsap.to(".unico-page-introduction-figure", 3, {autoAlpha: 1, delay: 0.5});

ScrollTrigger.matchMedia({
    "(max-width: 1024px)": function() {
        var introductionTimeline = gsap.timeline({
            scrollTrigger: { 
                trigger: document.querySelector(".unico-introduction-section"),
                start: "top top",
                end: "bottom top",
                pin: true, 
                scrub: 0.15,
                anticipatePin: 1
            }
        })
        
        introductionTimeline
            .to(".unico-introduction-content>h1", {opacity: 1, duration: 1});

        introductionTimeline.progress(1).progress(0);
    },
    "(min-width: 1025px)": function() {
        var introductionTimeline = gsap.timeline({
            scrollTrigger: { 
                trigger: document.querySelector(".unico-introduction-section"),
                start: "top top",
                end: "center top",//() => "+=" + 1.5 * document.querySelector('.unico-introduction-section').offsetHeight,
                pin: true,
                scrub: 0.15
            }
        })
        
        introductionTimeline
            .to(".unico-introduction-content>h1", {opacity: 1, duration: 1});
    }
})

// Handling Multifunctional section
document.documentElement.style.setProperty('--white-wine-scroll', 100 + "%");
            document.documentElement.style.setProperty('--bubble-wine-scroll', 100 + "%");
            document.documentElement.style.setProperty('--beer-scroll', 100 + "%");

var mfsect = gsap.to('.unico-multifunctional-section', {
    scrollTrigger: {
        trigger: '.unico-multifunctional-section',
        start: "top -=100", 
        end:  "300%",
        pin: true,
        scrub: 0.4,
        onEnter: (self) => {
            
            document.documentElement.style.setProperty('--white-wine-scroll', 100 + "%");
            // Here fix bubble wine parts left on the bottom
            document.documentElement.style.setProperty('--bubble-wine-scroll', 100 + "%"); 
        },
        onUpdate: (self) => {
            if( self.progress >= 0 && self.progress <= 1/3){
                document.documentElement.style.setProperty('--white-wine-scroll', (100 - (self.progress) * 100 / (1/3)) + "%");
                // Here fix bubble wine parts left on the bottom
                document.documentElement.style.setProperty('--bubble-wine-scroll', 100 + "%");
                // FIXME si dovrebbe fare in modo tale che cambia il colore anche dietro la navigation bar del browser
            }
            if( self.progress > 0.333333 && self.progress <= 2/3){
                // Here fix red wine parts left on the top 
                document.documentElement.style.setProperty('--white-wine-scroll', 0 + "%");
                document.documentElement.style.setProperty('--bubble-wine-scroll', (100 - (self.progress - (1/3)) * 100 / (1/3)) + "%");
                // Here fix bubble wine parts left on the bottom
                document.documentElement.style.setProperty('--beer-scroll', 100 + "%"); 
            } 
            if( self.progress > 2/3 && self.progress <= 1){
                // Here fix red wine parts left on the top
                document.documentElement.style.setProperty('--bubble-wine-scroll', 0 + "%");
                let beerSectionHeight = $("#unico-beer-section").height();
                document.documentElement.style.setProperty('--beer-scroll', (100 - (self.progress - (2/3)) * 100 / (1/3)) + "%");
            }
        },
        onLeave: (self) => {
            document.documentElement.style.setProperty('--white-wine-scroll', 0 + "%"); 
            document.documentElement.style.setProperty('--bubble-wine-scroll', 0 + "%");
            document.documentElement.style.setProperty('--beer-scroll', 0 + "%");
        },
        anticipatePin: 1

    }
})
document.documentElement.style.setProperty('--beer-section-height', $("#unico-beer-figure").height() + $("#unico-beer-figure").offset().top - $("#unico-beer-section").offset().top + 'px');
document.documentElement.style.setProperty('--multifunctional-section-padding-bottom',  ($("#unico-beer-figure").height() + $("#unico-beer-figure").offset().top - $("#unico-beer-section").offset().top - $(window).height()) + 'px');

// Levity Section
var windowsWidth = window.innerWidth;
var windowsHeight = window.innerHeight;

var unicoTransitionUrls = JSON.parse(
    document.getElementById("unico-transition-urls").innerHTML
);
const unicoTransitionCanvas = document.getElementById("unico-orbital-transition-figure");
const unicoTransitionContext = unicoTransitionCanvas.getContext("2d");
var unicoTransitionImgs = preloadImages(unicoTransitionUrls);

//.then((prova)=> {   console.log(prova)});
//unicoTransitionImgs = prova(unicoTransitionImgs);

unicoTransitionContext.canvas.width = windowsWidth;
unicoTransitionContext.canvas.height = windowsHeight;

var featherUrls = JSON.parse(
    document.getElementById("feather-urls").innerHTML
);
const featherCanvas = document.getElementById("unico-feather-figure");
const featherContext = featherCanvas.getContext("2d");
var featherImgs = preloadImages(featherUrls);
featherContext.canvas.width = windowsWidth;
featherContext.canvas.height = windowsHeight;

if(window.pageYOffset <= $(".unico-orbital-transition-content").offset().top) {
    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-bottom', '100%');
    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-top', '0%');
}
if(window.pageYOffset >= $(".unico-orbital-transition-content").height() + $(".unico-orbital-transition-content").offset().top) {
    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-bottom', '0%');
    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-top', '100%');
}

document.documentElement.style.setProperty('--orbital-transition-information-opacity', 0);
document.documentElement.style.setProperty('--orbital-transition-width', document.querySelector(".unico-orbital-transition-information").offsetWidth + "px");

var unicoTransitionScaleFactor = (windowsWidth/1920 >= windowsHeight/1080) ? windowsWidth / 1920 : windowsHeight / 1080;
var unicoTransitionImgsWidth = 1920 * unicoTransitionScaleFactor;
var unicoTransitionImgsHeight = 1080 * unicoTransitionScaleFactor; 
var unicoTransitionTranslationFactorX = (windowsWidth/1920 >= windowsHeight/1080) ? unicoTransitionImgsWidth / 4 : unicoTransitionImgsWidth / 3;
var unicoTransitionTranslationFactorY = (windowsWidth <= 768) ? Math.max(120, windowsHeight/5): 0;

$(window).resize(function(){
    // to handle canvas animation
    windowsWidth = window.innerWidth;
    windowsHeight = window.innerHeight;
    unicoTransitionContext.canvas.width = windowsWidth;
    unicoTransitionContext.canvas.height = windowsHeight;
    unicoTransitionScaleFactor = (windowsWidth/1920 >= windowsHeight/1080) ? windowsWidth / 1920 : windowsHeight / 1080
    unicoTransitionImgsWidth = 1920 * unicoTransitionScaleFactor;
    unicoTransitionImgsHeight = 1080 * unicoTransitionScaleFactor; 
    unicoTransitionTranslationFactorX = (windowsWidth/1920 >= windowsHeight/1080) ? unicoTransitionImgsWidth / 4 : unicoTransitionImgsWidth / 3;
    unicoTransitionTranslationFactorY = (windowsWidth <= 768) ? Math.max(120, windowsHeight/5): 0;
    featherContext.canvas.width = windowsWidth;
    featherContext.canvas.height = windowsHeight;
}); 

gsap.to("#unico-orbital-transition-figure", {
    scrollTrigger: {
        markers: false,
        trigger: '.unico-orbital-transition-content',
        start: "top top",
        end: () => "+=" + 3 * document.querySelector('.unico-orbital-transition-content').offsetHeight,// "bottom top",
        scrub: 0.15,
        pin: '.unico-orbital-transition-content',
        onEnter: (self) => {
            console.log(unicoTransitionImgs.length)
            unicoTransitionImgs.forEach((element, index) => {
                if(element.height == 0){
                    unicoTransitionImgs.splice(index, 1)
                }
            });
            console.log(unicoTransitionImgs.length)
        },
        onUpdate: (self) => {
            if(self.progress <= 0.5){
                let recomputedProgress = Math.floor(((self.progress) / 0.5 * 43));
                if (self.progress <= (35 / 88)) {
                    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-bottom', (100 - (self.progress / (34 / 88) * 100)) + '%');
                    document.documentElement.style.setProperty('--orbital-transition-information-opacity', self.progress / (34 / 88) );
                } 
                requestAnimationFrame(() => updateImage(recomputedProgress, unicoTransitionImgs, unicoTransitionContext, - unicoTransitionTranslationFactorX, unicoTransitionTranslationFactorY, unicoTransitionImgsWidth, unicoTransitionImgsHeight));// unicoTransitionContext, - unicoTransitionImgs[recomputedProgress].width / 3.5))

                

            } else {
                let recomputedProgress = 43 - Math.floor(((self.progress - 0.5) / 0.5 * 43));
                if (self.progress >= (54 / 88)) {
                    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-top', ((self.progress - (54 / 88)) / (34 / 88) * 100) + '%');
                    document.documentElement.style.setProperty('--orbital-transition-information-opacity', 1 - ((self.progress - (54 / 88)) / (34 / 88) ));
                }
                requestAnimationFrame(() => updateImage(recomputedProgress, unicoTransitionImgs, unicoTransitionContext, - unicoTransitionTranslationFactorX, unicoTransitionTranslationFactorY, unicoTransitionImgsWidth, unicoTransitionImgsHeight));// unicoTransitionContext, - unicoTransitionImgs[recomputedProgress].width / 3.5))
            }
        },
        onLeaveBack: (self) => {
            document.documentElement.style.setProperty('--orbital-transition-information-clip-from-bottom', '0%');
        },
        onRefresh: (self) => {
            if(self.progress <= 0.5){
                let recomputedProgress = Math.floor(((self.progress) / 0.5 * 43));
                if (self.progress <= (35 / 88)) {
                    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-bottom', (100 - (self.progress / (34 / 88) * 100)) + '%');
                    document.documentElement.style.setProperty('--orbital-transition-information-opacity', self.progress / (34 / 88) );
                } 
                requestAnimationFrame(() => updateImage(recomputedProgress, unicoTransitionImgs, unicoTransitionContext, - unicoTransitionTranslationFactorX, unicoTransitionTranslationFactorY, unicoTransitionImgsWidth, unicoTransitionImgsHeight));// unicoTransitionContext, - unicoTransitionImgs[recomputedProgress].width / 3.5))

            } else {
                let recomputedProgress = 43 - Math.floor(((self.progress - 0.5) / 0.5 * 43));
                if (self.progress >= (54 / 88)) {
                    document.documentElement.style.setProperty('--orbital-transition-information-clip-from-top', ((self.progress - (54 / 88)) / (34 / 88) * 100) + '%');
                    document.documentElement.style.setProperty('--orbital-transition-information-opacity', 1 - ((self.progress - (54 / 88)) / (34 / 88) ));
                }
                requestAnimationFrame(() => updateImage(recomputedProgress, unicoTransitionImgs, unicoTransitionContext, - unicoTransitionTranslationFactorX, unicoTransitionTranslationFactorY, unicoTransitionImgsWidth, unicoTransitionImgsHeight));// unicoTransitionContext, - unicoTransitionImgs[recomputedProgress].width / 3.5))
            }
        }
    }
});

var drawImageHeight;
var drawImageWidth;

if(windowsWidth / windowsHeight <= 1) {
    drawImageHeight = Math.max(featherImgs[2].height, windowsHeight);
    drawImageWidth = drawImageHeight * widthToHeight;
} else {
    if(windowsWidth / windowsHeight <= widthToHeight){
        drawImageHeight = Math.max(featherImgs[2].height, windowsHeight);
        drawImageWidth = drawImageHeight * widthToHeight;
    } else {
        drawImageWidth = Math.max(featherImgs[2].width, windowsWidth);
        drawImageHeight = windowsWidth / widthToHeight;
    }
}

$(window).resize(function(){
    if(windowsWidth / windowsHeight <= 1) {
        drawImageHeight = Math.max(featherImgs[2].height, windowsHeight);
        drawImageWidth = drawImageHeight * widthToHeight;
    } else {
        if(windowsWidth / windowsHeight <= widthToHeight){
            drawImageHeight = Math.max(featherImgs[2].height, windowsHeight);
            drawImageWidth = drawImageHeight * widthToHeight;
        } else {
            drawImageWidth = Math.max(featherImgs[2].width, windowsWidth);
            drawImageHeight = windowsWidth / widthToHeight;
        }
    }
}); 

var levityTimeline = gsap.timeline({
    scrollTrigger: {
        trigger: '.unico-feather-content',
        start: "top top",
        end: "bottom top",
        scrub: 0.15,
        pin: true,
        onEnter: (self) => {
            try{
                featherContext.drawImage(featherImgs[0], featherContext.canvas.width / 2  - drawImageWidth / 2, featherCanvas.height / 2  - drawImageHeight / 2, drawImageWidth, drawImageHeight);
            } catch {
                try {
                    featherContext.drawImage(featherImgs[1], featherContext.canvas.width / 2  - drawImageWidth / 2, featherCanvas.height / 2  - drawImageHeight / 2, drawImageWidth, drawImageHeight);
                } catch {
                    featherContext.drawImage(featherImgs[2], featherContext.canvas.width / 2  - drawImageWidth / 2, featherCanvas.height / 2  - drawImageHeight / 2, drawImageWidth, drawImageHeight);
                }
            }
            
        },
        onEnterBack: (self) => {
            $('body').css("backgroundColor", "black");
        },
        onUpdate: (self) => {
            if(self.progress >= 0.25){
                let recomputedProgress = Math.floor(((self.progress - 0.25) / 0.75 * 49));
                requestAnimationFrame(() => updateImage(recomputedProgress, featherImgs, featherContext, featherCanvas.width / 2  - drawImageWidth / 2, featherCanvas.height / 2  - drawImageHeight / 2, drawImageWidth, drawImageHeight));// unicoTransitionContext, - unicoTransitionImgs[recomputedProgress].width / 3.5))
            }
        },
        onLeave: (self) => {
            try{
                featherContext.drawImage(featherImgs[49], featherContext.canvas.width / 2  - drawImageWidth / 2, featherCanvas.height / 2  - drawImageHeight / 2, drawImageWidth, drawImageHeight);
            } catch {
                try{
                    featherContext.drawImage(featherImgs[48], featherContext.canvas.width / 2  - drawImageWidth / 2, featherCanvas.height / 2  - drawImageHeight / 2, drawImageWidth, drawImageHeight);
                } catch {
                }
            }
            $('body').css("backgroundColor", "white");
        },
        onRefresh: (self) => {
            if(self.progress >= 0.25){
                let recomputedProgress = Math.floor(((self.progress - 0.25) / 0.75 * 49));
                requestAnimationFrame(() => updateImage(recomputedProgress, featherImgs, featherContext, featherCanvas.width / 2  - drawImageWidth / 2, featherCanvas.height / 2  - drawImageHeight / 2, drawImageWidth, drawImageHeight));// unicoTransitionContext, - unicoTransitionImgs[recomputedProgress].width / 3.5))
            }
        }
    }
});

gsap.set("#unico-feather-figure", {autoAlpha: 0, y: - document.querySelector('#unico-feather-figure').offsetHeight/2});
levityTimeline
    .to("#unico-feather-figure", 0.5, {autoAlpha: 1, y: 0})
    .to("#unico-feather-figure", 1.5, {delay: 0.5});

// Handling Quality Section
var qualityTimeline = gsap.timeline({
    scrollTrigger: {
        trigger: '.unico-quality-section',
        start: "top top",
        end: () => "+=" + 5 * document.querySelector(".unico-quality-section").offsetHeight,
        scrub: 0.15,
        pin: true,
        anticipatePin: 1
    }
})

gsap.set("#unico-robustness-quality", {y: $(window).height()/2 - ($("#unico-robustness-quality").offset().top - $('.unico-quality-section').offset().top + $("#unico-robustness-quality").height() / 2)}) 

qualityTimeline
    .from("#unico-robustness-quality", {autoAlpha: 0, duration: 2}) 
    .from("#unico-quality-figure", {autoAlpha: 0, ease: "slow", duration: 2}, "+=2")
    .to("#unico-robustness-quality", {y: 0, duration: 2, ease: "slow"}, "<")
    .to("#unico-quality-figure", {autoAlpha: 0, duration: 2, ease: "slow"}, "+=2")
    .from(".unico-lazy-appearance-quality:not(#unico-robustness-quality)", {autoAlpha: 0, scale: 0.7, duration: 3, stagger: 0.4, ease: "none"})
    .from(".unico-lazy-appearance-quality:not(#unico-robustness-quality)", {y: document.querySelector(".unico-lazy-appearance-quality").offsetHeight, duration: 3, stagger: 0.4, ease: "none"}, "<")
    .to(".unico-lazy-appearance-quality", {y: - document.querySelector(".unico-lazy-appearance-quality").offsetHeight, autoAlpha: 0, duration: 3, scale: 0.7, stagger: 0.4, ease: "none"}, "+=2")
    .to(document.querySelector(".unico-quality-section"), {backgroundColor: "black", duration: 3})
    .to(document.body, {backgroundColor: "black", duration: 3}, "<")
    .from("#unico-everything", {opacity: 0, duration: 4}, "+=2")
    .from("#unico-in-a-glass", {opacity: 0, duration: 4}, "+=2")
    .to("#unico-everything", {opacity: 0, duration: 6}, "+=4")
    .to("#unico-in-a-glass", {opacity: 0, duration: 6}, "<");


// Handling Variants Section
/*var unicoVariantsTimeline = gsap.timeline({
    scrollTrigger: {
        trigger: '.unico-variants-section',
        start: "top top",
        end: "bottom top",
        pin: true, 
        scrub: 0.15,
        anticipatePin: 1
    }
});

unicoVariantsTimeline
    .from(".unico-variants-content>h2", {opacity: 0})
    .from(".unico-variants-content>h3", {opacity: 0}, "<")
    .from(".unico-variants-element", {opacity: 0}, "<")*/

document.documentElement.style.setProperty('--footer-height', $('#footer').height() + "px");

$("#unico-go-to-the-top").click(function(){
    gsap.to(window, {duration: 2, scrollTo: "#header"});
})